var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.366 22.6934V0.676453H45.3491V22.6934H67.366ZM48.5162 19.5771V3.88585H64.1482V19.5771H48.5162Z",
    fill: "#83B271"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2977 45.2184H45.3655V67.2353H67.2977V45.2184ZM48.4733 64.1275V48.5125H64.2238V64.1275H48.4733Z",
    fill: "#83B271"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.764648 0.735779V22.7104H22.7816V0.735779H0.764648ZM19.6145 3.94516V19.5772H3.93169V3.94516H19.6145Z",
    fill: "#83B271"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2661 38.7742V38.8419H64.3339L64.2661 38.7742Z",
    fill: "#83B271"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.658 35.7088V41.8312H64.2669V38.842H54.6557V32.5587H45.3408V35.7088H51.658Z",
    fill: "#83B271"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1988 29.1291V26.2245H45.3235V29.1291H64.1988Z",
    fill: "#83B271"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2661 38.7742L64.3339 38.8419V38.7742H64.2661Z",
    fill: "#83B271"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3406 32.6096H64.3345V38.7743H67.3406V32.6096Z",
    fill: "#83B271"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3574 41.8142H48.2874V38.9266H45.3574V41.8142Z",
    fill: "#83B271"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6087 32.457V32.3893H16.5325V32.457H16.6087Z",
    fill: "#83B271"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4163 35.5817H16.5325V32.4655H13.4163V35.5817Z",
    fill: "#83B271"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.395 41.8735H32.5113V35.6664H29.395V41.9074V41.8735Z",
    fill: "#83B271"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5113 44.9813H29.395V48.0976H32.5113V44.9813Z",
    fill: "#83B271"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9976 16.3254V7.07831H51.7505V16.3254H60.9976Z",
    fill: "#83B271"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.964 60.952V51.7049H51.7V60.952H60.964Z",
    fill: "#83B271"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18311 7.08679V16.3339H16.4471V7.08679H7.18311Z",
    fill: "#83B271"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7097 32.3978H26.16V26.0976V26.0298H26.0923V26.0976H16.7097V32.3978Z",
    fill: "#83B271"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6621 0.701904H32.5713V6.96826H35.6621V0.701904Z",
    fill: "#83B271"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.336 0.701904H26.2451V6.96826H29.336V0.701904Z",
    fill: "#83B271"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8711 0.735779V10.1268H41.8772V0.735779H38.8711Z",
    fill: "#83B271"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6528 22.9643H38.8114V26.0721H29.2594V29.1291H38.8114V32.2453H35.6104V51.5779V54.6687H41.8768V51.5779H38.8791V38.9605H41.9276V16.3254H38.9807V13.3446H35.6782V10.1268H32.5873V13.3446H26.2617V19.8735H29.2848V22.9643H32.5873V19.9158H29.3356V16.4355H38.8114V19.9158H35.6528V22.9643Z",
    fill: "#83B271"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5854 60.952H41.8518V57.8611H35.704H35.6363H35.5854V60.952Z",
    fill: "#83B271"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8176 67.1676V64.1699H32.4265V67.1676H41.8176Z",
    fill: "#83B271"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2085 64.2545V60.952H32.4263V57.8612H29.2085V51.5355H22.6796V54.5586H19.6311V57.8612H22.6796V54.6264H26.16V64.1021H22.6796V60.952H19.6311V64.1021H16.4386V60.9351H13.3478V64.1021H10.113V60.9351H7.02218V64.1021H3.80432V57.768H0.806641V67.1591H3.63496H26.2277V64.2207L29.2085 64.2545Z",
    fill: "#83B271"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6313 44.9644H23.1371V48.2669H26.1856V44.9644H29.395V41.8735H26.1856V38.571H23.1371V41.8735H19.6313V44.9644Z",
    fill: "#83B271"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1138 57.768V54.5586H13.4502V57.7426H16.4394V54.5586V48.0212H13.4163V44.9812H10.1138V48.0297H13.3486V51.5101H3.87283V48.0297H7.02294V44.9812H3.87283V41.8734H13.4163V38.8165H3.87283V28.9766H0.781982V51.5694H3.72039V54.5586H7.02294V57.768H10.1138Z",
    fill: "#83B271"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.e92522f35b7671c1a1d75a85b409d030.svg";
export { ForwardRef as ReactComponent };